import { render, staticRenderFns } from "./second-factor.vue?vue&type=template&id=1a7ab44c&"
import script from "./second-factor.vue?vue&type=script&lang=ts&"
export * from "./second-factor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports